// extracted by mini-css-extract-plugin
module.exports = {"backButton":"backToProjects_backButton__lslQM","backButtonLine":"backToProjects_backButtonLine__YIA8t","backButtonText":"backToProjects_backButtonText__qD6Ya"};